/** @type {import('./src/index').ResponsiveGridClass} */
export { default, ResponsiveGridClass } from './src/index';
